Utils = {};

Utils._autoClickForReplayRewatchTimer = undefined;
Utils.autoClickForReplayRewatch = function (cb, time = 4000) {
  if (gdk.serverParser._inReplayMode || gdk.serverParser._inRewatchMode) {
    Utils.stopAutoClickForReplayRewatch(); // just in case
    Utils._autoClickForReplayRewatchTimer = timerManager.addTimeout(time, cb);
  }
};

Utils.stopAutoClickForReplayRewatch = function () {
  if (Utils._autoClickForReplayRewatchTimer) {
    timerManager.stop(Utils._autoClickForReplayRewatchTimer);
    Utils._autoClickForReplayRewatchTimer = undefined;
  }
};

Utils.distanceBetweenTwoPoints = function (p1, p2) {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  return Math.sqrt(dx * dx + dy * dy);
};

Utils.cleanArray = function (arr, value) {
  return arr.filter((num) => num !== value);
};

Utils.degreesToRadians = function (degrees) {
  return degrees * (Math.PI / 180);
};

Utils.isFunction = function (func) {
  let result = false;
  if (func) {
    result = toString.call(func) === '[object Function]' || toString.call(func) === '[object AsyncFunction]';
  }
  return result;
};

Utils.isPromise = function (promise) {
  let result = false;
  if (promise) {
    result = Utils.isFunction(promise.then);
  }
  return result;
};

Utils.isObject = function (obj) {
  let result = false;
  if (obj) {
    result = Object.getPrototypeOf(obj) === Object.getPrototypeOf({});
  }
  return result;
};

Utils.isNull = function (val) {
  let result = false;
  if (val === null) {
    result = true;
  }
  return result;
};

Utils.isUndefined = function (val) {
  let result = false;
  if (typeof val === 'undefined') {
    result = true;
  }
  return result;
};

Utils.isString = function (val) {
  let result = false;
  if (typeof val === 'string') {
    result = true;
  }
  return result;
};

Utils.isNumber = function (val) {
  let result = false;
  if (typeof val === 'number') {
    result = true;
  }
  return result;
};

Utils.isBoolean = function (val) {
  let result = false;
  if (typeof val === 'boolean') {
    result = true;
  }
  return result;
};

Utils.isArray = function (val) {
  let result = false;
  if (Array.isArray(val) === true) {
    result = true;
  }
  return result;
};

Utils.removeFirstArrayElement = function (arr) {
  arr.shift();
  return arr;
};

Utils.removeLastArrayElement = function (arr) {
  arr.pop();
  return arr;
};

Utils.fillArray = function (array, value, amount = array.length) {
  if (Utils.isArray(array)) {
    for (let i = 0; i < amount; i++) {
      array[i] = value;
    }
  }
  return array;
};

Utils.swapArrayElements = function (array, index1, index2) {
  let temp = array[index1];
  array[index1] = array[index2];
  array[index2] = temp;
  return array;
};

Utils.waitForever = async function () {
  let resolver = null;
  const promise = new Promise((resolve) => {
    resolver = resolve;
  });
  await promise;
};

Utils.randomNumberBetween = function (min, max) {
  min = Math.ceil(min);
  max = Math.floor(max + 1);
  // could this rng be bought into Utils?
  const random = gameController.rng().nextFloat();
  return Math.floor(random * (max - min)) + min;
};

Utils.playSpineAsync = async function (animName, spineAnim, hideWhenFinished = true) {
  let resolver = null;
  const promise = new Promise((resolve) => {
    resolver = resolve;
  });

  spineAnim.visible = true;
  spineAnim.spineObject.state.timeScale = 1;
  spineAnim.spineObject.state.clearListeners();

  spineAnim.play(animName, false, 0, () => {
    resolver();
  });

  await promise;

  if (hideWhenFinished) {
    spineAnim.visible = false;
  }
};

Utils.playMovieAsync = async function (movie, hideWhenFinished = true) {
  movie.visible = true;
  let resolver = null;
  const promise = new Promise((resolve) => {
    resolver = resolve;
  });
  movie.gotoAndPlay(0);
  movie.onComplete = () => {
    resolver();
  };
  await promise;
  if (hideWhenFinished) {
    movie.visible = false;
  }
};

Utils.tweenFromToAsync = async function (targets, fromVars, toVars, tweenInfo = null) {
  let resolver = null;
  const tweenPromise = new Promise((resolve) => {
    resolver = resolve;
  });

  const origOnComplete = toVars.onComplete;
  toVars.paused = true;
  toVars.onComplete = () => {
    if (origOnComplete) {
      origOnComplete();
    }
    resolver();
  };

  const tween = gsap.fromTo(targets, fromVars, toVars);
  tween.time(0).restart(true);

  if (tweenInfo) {
    tweenInfo.tween = tween;
    tweenInfo.resolver = resolver;
    tweenInfo.promise = tweenPromise;
  }

  return tweenPromise;
};

const textProto = PIXI.Text.prototype;
const originalDescriptor = Object.getOwnPropertyDescriptor(textProto, 'text');

Object.defineProperty(textProto, 'text', {
  get: originalDescriptor.get,
  set: function (input) {
    let value = input == null ? '' : String(input);

    const TOKEN = '\uFFF0';
    const protectedParts = [];

    if (this.style && this.style.breakWords) {
      value = value.replace(/(?:\d+(?:[.,]\d+)*(?:倍)?|\d+\s*~\s*\d+|倍回)/g, (match) => {
        protectedParts.push(match);
        return TOKEN;
      });
    }

    if (this.style && this.style.wordWrap && !this.style.breakWords) {
      const locale = gdk.getCurrentLanguage();

      if (locale === 'ja') {
        value = value.replace(/([\p{Script=Hiragana}\p{Script=Katakana}])/gu, '$1\u200A');
        value = value.replace(/\u200A([、。！？；（）「」『』・〜])/g, '$1');
      } else if (locale === 'zh_hant' || locale === 'zh_hans') {
        value = value.replace(/([\p{Script=Han}])/gu, '$1\u200A');
        value = value.replace(/\u200A([、。！？；：，（）“”‘’「」『』…·])/g, '$1');
      } else if (locale === 'th') {
        value = value.replace(/([\p{Script=Thai}])/gu, '$1\u200A');
        value = value.replace(/\u200A([ๆฯ“”‘’；（）…])/g, '$1');
      }
    }

    if (protectedParts.length > 0) {
      let i = 0;
      value = value.replace(new RegExp(TOKEN, 'g'), () => protectedParts[i++]);
    }

    originalDescriptor.set.call(this, value);
  },
});

// game specific below

Utils.shrinkArrayBasedOnBlockDistribution = function (arr, blockDistribution, cloneArrays = true) {
  // arr = [[true, false, false, false],
  //        [true, false, false, false],
  //        [true, true, false, false],
  //        [true, true, false, false],
  //        [true, false, false, false]]
  // blockDistribution = "1-1-2-1"
  // [[true, false, false, false],
  //  [true, false, false, false],
  //  [true, true, false, false],
  //  [true, false, false, false]]
  // basically gigablox reels get reduced to 1
  if (Utils.isUndefined(arr)) {
    return undefined;
  }
  const newArr = [];
  const widths = blockDistribution.split('-').map(Number);
  let arrIndex = 0;
  for (let w = 0; w < widths.length; w++) {
    const width = widths[w];
    if (Utils.isArray(arr[arrIndex]) === true && cloneArrays === true) {
      // clone so references don’t leak
      newArr[w] = arr[arrIndex].slice();
    } else {
      newArr[w] = arr[arrIndex]; // take element for 1D
    }
    arrIndex += width;
  }
  return newArr;
};

Utils.expandArrayBasedOnBlockDistribution = function (arr, blockDistribution) {
  // arr = [[true, false, false, false],
  //        [true, false, false, false],
  //        [true, true, false, false],
  //        [true, false, false, false]]
  // blockDistribution = "1-1-2-1"
  // =>
  // [[true, false, false, false],
  //  [true, false, false, false],
  //  [true, true, false, false],
  //  [true, true, false, false],
  //  [true, false, false, false]]
  const newArr = [];
  const widths = blockDistribution.split('-').map(Number);
  let arrIndex = 0;
  for (let w = 0; w < widths.length; w++) {
    const width = widths[w];
    const sourceColumn = arr[w];
    for (let i = 0; i < width; i++) {
      // clone so references don’t leak
      newArr[arrIndex++] = sourceColumn.slice(0);
    }
  }

  return newArr;
};

Utils.isGigaReel = function (reelIndex, blockDistribution) {
  const widths = blockDistribution.split('-').map(Number);
  let currentIndex = 0;
  for (let i = 0; i < widths.length; i++) {
    const width = widths[i];
    if (reelIndex < currentIndex + width) {
      return width > 1;
    }
    currentIndex += width;
  }

  return false;
};

// reelIndex 0 - 4
// blockDistribution = "1-1-1-1-1" or "2-1-1-1" or "3-1-1" or multiples
Utils.widthOfReel = function (reelIndex, blockDistribution) {
  const widths = blockDistribution.split('-').map(Number);
  let currentIndex = 0;
  for (let i = 0; i < widths.length; i++) {
    const width = widths[i];
    if (reelIndex < currentIndex + width) {
      return width;
    }
    currentIndex += width;
  }

  return 1;
};

Utils.reelIndexToGigaReelIndex = function (reelIndex, blockDistribution) {
  const widths = blockDistribution.split('-').map(Number);
  let currentIndex = 0;

  for (let gigaIndex = 0; gigaIndex < widths.length; gigaIndex++) {
    const width = widths[gigaIndex];
    if (reelIndex < currentIndex + width) {
      return gigaIndex;
    }
    currentIndex += width;
  }

  return -1;
};

Utils.gigaReelIndexToReelIndex = function (gigaReelIndex, blockDistribution) {
  const widths = blockDistribution.split('-').map(Number);

  if (gigaReelIndex < 0 || gigaReelIndex > widths.length) {
    return -1;
  }

  let reelIndex = 0;

  for (let i = 0; i < gigaReelIndex; i++) {
    reelIndex += widths[i];
  }

  return reelIndex;
};

Utils.calcSymbolsBelow = function (data) {
  const below = [];
  const widths = data.blockDistribution.split('-').map(Number);

  // lets 1st look at blockDistribution and colossal symbols
  // overhanging the bottom
  const board = data.board;
  let reelIndex = 0;
  for (let i = 0; i < widths.length; i++) {
    const column = board.columns[i];
    const width = widths[i];

    for (let j = 0; j < width; j++) {
      const reelList = board.stopWindow.reelList[reelIndex];
      if (width > 1) {
        const height = column.rows[column.rows.length - 1].height;
        if (height === 1) {
          // this means we have bonus symbols across the bottom
          // leave the code below to pick random symbols
        } else {
          if (column.shift === 1) {
            // this means we have overhang at the top 2x2 or 3x3
            // but no overhang on the bottom,
            // leave the code below to pick random symbols
          } else {
            // this means the symbol is overhanging
            // so we need to duplicate whats at the bottom of the window
            if (!Utils.isArray(below[reelIndex])) {
              below[reelIndex] = [];
            }
            // how many should we add?
            let amountToAdd = column.shift;
            if (column.shift === 0) {
              amountToAdd = 1;
            }
            const symbolID = reelList.symbols[reelList.symbols.length - 1].value;
            for (let k = 0; k < amountToAdd; k++) {
              below[reelIndex].push(symbolID);
            }
          }
        }
      }

      reelIndex++;
    }
  }

  if (data.fillEmptyGaps) {
    // now look for empty gaps
    const symbolConfig = resourceManager.getConfiguration().symbols;
    const bonusID = symbolConfig['Bonus'].ID;
    const allowedSymbols = Globals.ALLOWED_SYMBOLS.slice(0);
    const allowedSymbolsWithBonus = allowedSymbols.concat([bonusID]);
    reelIndex = 0;
    for (let i = 0; i < widths.length; i++) {
      let allowedSymbolsToUse = allowedSymbolsWithBonus;
      const reelList = board.stopWindow.reelList[reelIndex];
      const symbolsFromAbove = Utils.isArray(data.symbolsAbove[reelIndex]) ? data.symbolsAbove[reelIndex] : [];
      const width = widths[i];

      if (data.disableBonusTease) {
        // dont tease bonus symbols
        allowedSymbolsToUse = allowedSymbols;
      } else {
        // bonus tease allowed, but double check above
        // 11 should only be allowed if we dont have one on the reels already!
        // lets look on this reel to see if a bonus symbol is already on the reels
        for (let s = 0; s < reelList.symbols.length; s++) {
          if (reelList.symbols[s].value === bonusID) {
            // bonus already on the reels, cant tease 1 below
            // use the other array
            allowedSymbolsToUse = allowedSymbols;
            break;
          }
        }

        // not just the reels we need to check, also whats been fudged in symbolsAbove
        for (let s = 0; s < symbolsFromAbove.length; s++) {
          if (symbolsFromAbove[s] === bonusID) {
            // bonus already in the symbolsAbove
            // use the other array
            allowedSymbolsToUse = allowedSymbols;
            break;
          }
        }
      }

      const randomId = allowedSymbolsToUse[Utils.randomNumberBetween(0, allowedSymbolsToUse.length - 1)];
      for (let j = 0; j < width; j++) {
        if (!Utils.isArray(below[reelIndex])) {
          // nothing picked for this reel yet
          below[reelIndex] = [];
          // can only add 1 lot of bonus ids
          const amountToAdd = randomId !== bonusID ? width : 1;
          for (let k = 0; k < amountToAdd; k++) {
            below[reelIndex].push(randomId);
          }
        }
        reelIndex++;
      }
    }
  }

  return below;
};

Utils.convertBlockDistributionToGigabloxLayout = function (blockDistribution) {
  // we go from "1-1-1-2"
  // to
  // [[0],[1],[2],[3,4]]
  const widths = blockDistribution.split('-').map(Number);
  const gigabloxLayout = [];
  let reelIndex = 0;
  for (let w = 0; w < widths.length; w++) {
    const width = widths[w];
    if (!Utils.isArray(gigabloxLayout[w])) {
      gigabloxLayout[w] = [];
    }
    for (let i = 0; i < width; i++) {
      gigabloxLayout[w].push(reelIndex);
      reelIndex++;
    }
  }
  return gigabloxLayout;
};

Utils.randomPreSymbolsForPreSpinCleanUp = function (width) {
  const symbols = [];

  const allowedSymbols = Globals.ALLOWED_SYMBOLS.slice(0);

  while (symbols.length < Globals.NUM_PRE_APPERATURE_SYMBOLS) {
    const randomId = allowedSymbols[Utils.randomNumberBetween(0, allowedSymbols.length - 1)];
    for (let i = 0; i < width && symbols.length < Globals.NUM_PRE_APPERATURE_SYMBOLS; i++) {
      symbols.push(randomId);
    }
  }

  return symbols;
};

Utils.groupSymbols = function (symbols, size) {
  const result = [];
  const chunks = [];

  let chunkIndex = 0;

  for (let i = 0; i < symbols.length; i++) {
    const symbol = symbols[i];
    // lets break this into chunks
    if (!chunks[chunkIndex]) {
      chunks[chunkIndex] = [];
    }

    chunks[chunkIndex].push(symbol);

    let count = 1;
    if (symbol !== Globals.BONUS_ID) {
      while (symbols[i + count] === symbol && count < size) {
        chunks[chunkIndex].push(symbol);
        count++;
      }
    }

    i += count - 1;
    chunkIndex++;
  }

  // e.g if we passed in 2, 11, 9, 9, 9, 0, 0 ans size of 2
  // we would have chunks looking like
  // [2]
  // [11]
  // [9, 9]
  // [9]
  // [0, 0]

  // now lets go an add extra if needed
  for (let i = 0; i < chunks.length; i++) {
    if (chunks[i].length < size && chunks[i][0] !== Globals.BONUS_ID) {
      const diff = size - chunks[i].length;
      for (let k = 0; k < diff; k++) {
        chunks[i].push(chunks[i][0]);
      }
    }
  }

  // [2, 2]
  // [11]
  // [9, 9]
  // [9, 9]
  // [0, 0]

  for (let i = 0; i < chunks.length; i++) {
    for (let k = 0; k < chunks[i].length; k++) {
      result.push(chunks[i][k]);
    }
  }

  // [2, 2, 11, 9, 9, 9, 9, 0, 0]

  return result;
};
